import React, { Fragment } from "react";
import Fade from "react-reveal/Fade";
import Flip from "react-reveal/Flip";
import { News } from "../../Data/Data";
import { Link } from "react-router-dom";

function convertToSlug(text) {
  return text.trim().toLowerCase().replace(/\s+/g, "-");
}

function AnnualBanner() {
  return (
    <Fragment>
      <div className="container governancemain motor">
        <div className="row arrticleAndBlogs">
          <div className="col-sm-12 heads govbanner awards">
            <Fade up delay={500}>
              <h2 className="oswald">Awards and Recognition</h2>
            </Fade>
          </div>

          <div className="col-sm-12 heads text news">
            <div className="row ArticlesAndBlogs">
              {News.map((data) => {
                const trimmedContent = data?.content.split(" ").slice(0, 30).join(" ") + (data.content.split(" ").length > 30 ? "..." : "");
                return (
                  <div className="col-sm-4">
                    <Fade right delay={500}>
                      <Link
                        to={`/awards-&-recognition/${data.Key}`}
                        onClick={() => {
                          window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                          });
                        }}
                      >
                        <div className="menusildes" key={data.Key}>
                          <Flip top delay={500}>
                            {" "}
                            <img src={data.feature} alt="" />
                          </Flip>
                          <Fade up delay={500}>
                            <p>{trimmedContent}</p>
                          </Fade>
                        </div>
                      </Link>
                    </Fade>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default AnnualBanner;
